var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageTitle',{attrs:{"route":_vm.$route}}),_c('PageRowWrapper',[(Object.keys(_vm.contract).length)?_c('FinancialContractForm',{attrs:{"contract":_vm.contract}}):_vm._e(),(!_vm.contract)?_c('LoadingPage'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }